module.exports = __webpack_public_path__ + "static/img/training.4678b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/training.png
// module id = Rp7y
// module chunks = 0